import { render, staticRenderFns } from "./countPupilBar.vue?vue&type=template&id=fdffd36a&scoped=true"
import script from "./countPupilBar.vue?vue&type=script&lang=js"
export * from "./countPupilBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdffd36a",
  null
  
)

export default component.exports